import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Table } from "@/features/Table";
import { type N1DataUpload, data_upload_columns } from "./columns";
import UploadPopover from "@/components/UploadPopover";
import { type FilterN1DataUploadSchema, N1DataUploadFilter } from "./filter";
import { N1DataUploadNew } from "./new";
import { useQueryClient } from "@tanstack/react-query";
import { Clients } from "@/lib/clients";
import { ClientTables } from "@/lib/clientTables";

export const N1DataUploadTable = () => {
  const [searchParams] = useSearchParams();
  const [files, setFiles] = useState<File[]>([]);
  const [selectedConfig, setSelectedConfig] = useState<string | null>(null);
  const client = searchParams.get("client") || Clients.N1;

  const QueryClient = useQueryClient();
  const refreshList = async () => {
    // In v5, this invalidates all queries whose key starts with the prefix
    await QueryClient.invalidateQueries({
      queryKey: [client, ClientTables.N1_DATA_UPLOAD, "get"],
    });
  };

  return (
    <Table<N1DataUpload, FilterN1DataUploadSchema>
      label="Chargement de fichiers"
      client={client}
      table_name={ClientTables.N1_DATA_UPLOAD}
      columns={data_upload_columns}
      filter={<N1DataUploadFilter />}
      disable_translations_request={true}
      new_item={
        <UploadPopover
          uploader={({ setIsOpen }) => (
            <N1DataUploadNew
              setIsOpen={setIsOpen}
              files={files}
              setFiles={setFiles}
              selectedConfig={selectedConfig}
              setSelectedConfig={setSelectedConfig}
              onSuccess={async () => {
                await refreshList();
              }}
            />
          )}
        />
      }
    />
  );
};
